import { Component, Element, h, Host, Prop, Watch } from '@stencil/core';

import { state as headerState } from './pn-marketweb-siteheader-store';
import { LoginDialog } from './pn-marketweb-siteheader-types';

@Component({
  tag: 'pn-marketweb-siteheader-login-links',
  styleUrl: 'pn-marketweb-siteheader-login-links.scss',
})
export class PnMarketwebSiteheaderLoginLinks {
  @Element() hostElement: HTMLElement;

  // Login dialog
  @Prop({ mutable: true }) loginDialog: LoginDialog = null;
  @Prop() idNamespace: string = '';
  @Prop({ reflect: true }) loggedin: boolean = false;
  @Prop() username: string = '';
  @Prop() showUnifiedLogin: boolean = false;

  componentWillLoad() {
    this.init();
  }

  @Watch('loginDialog')
  async init() {
    this.adjustLoginLinks();
  }
  adjustLoginLinks() {
    if (!this.loginDialog) {
      return;
    }

    const adjustLink = (link, i) => {
      if (!link.isLogoutLink) {
        link.isLogoutLink = link.pageLink.indexOf('location.href') !== -1 && link.pageLink.indexOf('logout') !== -1;
      }
      if (link.isLogoutLink) {
        link.href = headerState.loginManager.getLogoutUrl(link.href);
      }
      link.href = link.href.replace('window.location.href', window.location.href);
      if (i === 0 && !link.href) {
        link.href = headerState.loginManager.getLoginUrl();
        link.linkType = 'primary';
      }
      if (link.primaryLinkApperance && !link.linkType) {
        link.linkType = 'primary';
      }
    };

    if (this.loginDialog?.loginMenuLinks) {
      this.loginDialog?.loginMenuLinks.forEach(adjustLink);
    }
    if (this.loginDialog?.loggedInLinks) {
      this.loginDialog?.loggedInLinks.forEach(adjustLink);
    }

    this.loginDialog.legacyLoginLinks = [
      {
        href: headerState.loginManager.getLoginUrl(this.loginDialog.loginUrl),
        linkText: this.loginDialog.loginLinkText,
        openInNewWindow: false,
        isLogoutLink: false,
        pageLink: null,
        linkType: 'primary',
        primaryLinkApperance: true,
      },
      {
        href: headerState.loginManager.getLoginUrl(this.loginDialog.registerUrl),
        linkText: this.loginDialog.createLoginLinkText,
        openInNewWindow: false,
        isLogoutLink: false,
        pageLink: null,
        primaryLinkApperance: false,
      },
    ];
  }

  render() {
    if (!this.loginDialog) {
      return;
    }

    let hostElementAttribute = {
      username: null,
      loggedin: false,
    };
    if (this.username) {
      hostElementAttribute.username = this.username;
      hostElementAttribute.loggedin = this.loggedin;
    }
    return (
      <Host {...hostElementAttribute}>
        {!this.loginDialog.overrideLoginMenu ? (
          <div data-loggedin={this.loggedin + ''}>
            {this.loggedin ? (
              <pn-marketweb-siteheader-login-linklist links={this.loginDialog.loggedInLinks} idNamespace={this.idNamespace}></pn-marketweb-siteheader-login-linklist>
            ) : (
              <div>
                {/* Get login links from API */}
                {this.loginDialog.loginMenuLinks?.length > 0 ? (
                  <pn-marketweb-siteheader-login-linklist
                    heading={this.loginDialog.loginTitle}
                    links={this.loginDialog.loginMenuLinks}
                    idNamespace={this.idNamespace}
                    showUnifiedLogin={this.showUnifiedLogin}
                  ></pn-marketweb-siteheader-login-linklist>
                ) : (
                  <pn-marketweb-siteheader-login-linklist links={this.loginDialog.legacyLoginLinks} idNamespace={this.idNamespace}></pn-marketweb-siteheader-login-linklist>
                )}
              </div>
            )}
          </div>
        ) : null}

        {/* Override the default logic for some markets such as DK */}
        {this.loginDialog.overrideLoginMenu ? (
          <pn-marketweb-siteheader-login-linklist links={this.loginDialog.loginMenuLinks} idNamespace={this.idNamespace}></pn-marketweb-siteheader-login-linklist>
        ) : null}
      </Host>
    );
  }
}
